<template>
  <div>
    <el-card class="box-card">
      <div>
        <el-card class="form-card">
          <el-form ref="form" v-model="form" label-width="80px">
            <el-row>
              <el-col :span="6">
                <el-form-item label="商家">
                  <el-select v-model="form.ptnCode" style="width:50%">
                    <el-option v-for="item in PartnerLists" :key="item.id" :label="item.ptnName" :value="item.ptnCode"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="仓库">
                  <el-select v-model="form.strCode" style="width:50%">
                    <el-option v-for="item in storeLists" :key="item.id" :label="item.strName" :value="item.strCode"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="货主ID">
                  <el-input v-model="form.ownerCode"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item>
                  <el-button @click="dialogFormVisible = true">新增</el-button>
                  <el-button type="primary" @click="onSubmit">搜索</el-button>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </el-card>
      </div>
    </el-card>

    <el-table :data="ptnStrLists" v-loading="loading" border stripe style="width: 100%" height="500">
      <el-table-column type="index" label="#"></el-table-column>
      <el-table-column prop="ptnCode" label="商家编号"></el-table-column>
      <el-table-column prop="strCode" label="仓库编号"></el-table-column>
      <el-table-column prop="ownerCode" label="货主ID"></el-table-column>
      <el-table-column prop="ownerName" label="货主名称"></el-table-column>
      <el-table-column prop="warehouseCode" label="仓库ID"></el-table-column>

      <el-table-column label="操作">
        <template slot-scope="scope">
          <!-- 编辑 -->
          <el-tooltip effect="dark" content="编辑" placement="top" :enterable="false">
            <el-button type="primary" icon="el-icon-edit" size="mini" @click="showEditDilog(scope.row)"></el-button>
          </el-tooltip>

          <!-- 删除 -->
          <el-tooltip effect="dark" content="删除" placement="top" :enterable="false">
            <el-button type="danger" icon="el-icon-delete" size="mini" @click="delPtnStr(scope.row.id)"></el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>

    <div class="block">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="queryInfo.pagesize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </div>

    <el-dialog title="新增" :visible.sync="dialogFormVisible" width="50%" @close="addDilogClosed" :close-on-click-modal="false">
      <el-form :model="addform" ref="addformRef" :rule="rules" size="mini" :rules="rules">
        <el-form-item label="商家" prop="ptnCode" :label-width="formLabelWidth">
          <el-select v-model="addform.ptnCode" placeholder="请选择商家" style="width:50%" @change="changePtn">
            <el-option v-for="item in PartnerLists" :key="item.id" :label="item.ptnName" :value="item.ptnCode"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="仓库" prop="strCode" :label-width="formLabelWidth">
          <el-select v-model="addform.strCode" placeholder="请选择仓库" style="width:50%" @change="changeStr">
            <el-option v-for="item in storeLists" :key="item.id" :label="item.strName" :value="item.strCode"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="货主名称" prop="ownerName" :label-width="formLabelWidth">
          <el-input v-model="addform.ownerName" autocomplete="on" style="width:50%"></el-input>
        </el-form-item>

        <el-form-item label="货主ID" prop="ownerCode" :label-width="formLabelWidth">
          <el-input v-model="addform.ownerCode" autocomplete="on" style="width:50%"></el-input>
        </el-form-item>
        <el-form-item label="仓库ID" prop="warehouseCode" :label-width="formLabelWidth">
          <el-input v-model="addform.warehouseCode" autocomplete="on" style="width:50%" :disabled="true"></el-input>
        </el-form-item>

        <el-form-item label="API地址" :label-width="formLabelWidth">
          <el-input v-model="addform.apiUrl" autocomplete="on" style="width:50%" :disabled="true"></el-input>
        </el-form-item>

        <el-form-item label="FTP地址" :label-width="formLabelWidth">
          <el-input v-model="addform.ftpUrl" autocomplete="on" style="width:50%" :disabled="true"></el-input>
        </el-form-item>

        <el-form-item label="FTP账号" :label-width="formLabelWidth">
          <el-input v-model="addform.ftpAccount" autocomplete="on" style="width:50%"></el-input>
        </el-form-item>

        <el-form-item label="FTP密码" :label-width="formLabelWidth">
          <el-input v-model="addform.ftpPassword" autocomplete="on" style="width:50%"></el-input>
        </el-form-item>

        <el-form-item label="白名单" :label-width="formLabelWidth">
          <el-input v-model="addform.ipWhitelist" autocomplete="on" style="width:50%"></el-input>
        </el-form-item>

        <el-form-item label="是否B2B" :label-width="formLabelWidth">
          <el-radio-group v-model="addform.hasB2b" @change="changeAddB2b">
            <el-radio label="T">是</el-radio>
            <el-radio label="F">否</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="备注" :label-width="formLabelWidth">
          <el-input v-model="addform.memo" autocomplete="on" style="width:50%" maxlength="64"></el-input>
        </el-form-item>

        <el-form-item label="库存分配" :label-width="formLabelWidth">
          <el-table :data="addform.shops">
            <el-table-column prop="shopName" label="店铺名称"></el-table-column>

            <el-table-column prop="prop" label="分配方式">
              <template slot-scope="scope">
                <el-form-item>
                  <el-select v-model="scope.row.disType" placeholder="请选择" style="width:130Px">
                    <el-option v-for="types in allotType" :key="types.value" :label="types.label" :value="types.value"></el-option>
                  </el-select>
                </el-form-item>
              </template>
            </el-table-column>

            <el-table-column prop="prop" label="百分比(数量)">
              <template slot-scope="scope">
                <el-form-item>
                  <el-input v-model="scope.row.combPercent"></el-input>
                </el-form-item>
              </template>
            </el-table-column>

            <el-table-column prop="prop" label="优先级">
              <template slot-scope="scope">
                <el-input-number v-model="scope.row.priority" :min="1" :max="30"></el-input-number>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align:center">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="addPtnStore">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="编辑" :visible.sync="editdialogFormVisible" width="50%" @close="editDilogClosed" :close-on-click-modal="false">
      <el-form :model="editform" ref="editformRef" :rule="rules" size="mini" :rules="rules">
        <el-form-item label="商家" prop="ptnCode" :label-width="formLabelWidth">
          <el-select v-model="editform.ptnCode" placeholder="请选择商家" style="width:50%">
            <el-option v-for="item in PartnerLists" :key="item.id" :label="item.ptnName" :value="item.ptnCode"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="仓库" prop="strCode" :label-width="formLabelWidth">
          <el-select v-model="editform.strCode" placeholder="请选择仓库" style="width:50%" @change="changeEditStr">
            <el-option v-for="item in storeLists" :key="item.id" :label="item.strName" :value="item.strCode"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="货主ID" prop="ownerCode" :label-width="formLabelWidth">
          <el-input v-model="editform.ownerCode" autocomplete="on" style="width:50%"></el-input>
        </el-form-item>

        <el-form-item label="仓库ID" prop="warehouseCode" :label-width="formLabelWidth">
          <el-input v-model="editform.warehouseCode" autocomplete="on" style="width:50%" :disabled="true"></el-input>
        </el-form-item>

        <el-form-item label="API地址" :label-width="formLabelWidth">
          <el-input v-model="editform.apiUrl" autocomplete="on" style="width:50%" :disabled="true"></el-input>
        </el-form-item>

        <el-form-item label="FTP地址" :label-width="formLabelWidth">
          <el-input v-model="editform.ftpUrl" autocomplete="on" style="width:50%" :disabled="true"></el-input>
        </el-form-item>

        <el-form-item label="FTP账号" :label-width="formLabelWidth">
          <el-input v-model="editform.ftpAccount" autocomplete="on" style="width:50%"></el-input>
        </el-form-item>

        <el-form-item label="FTP密码" :label-width="formLabelWidth">
          <el-input v-model="editform.ftpPassword" autocomplete="on" style="width:50%"></el-input>
        </el-form-item>

        <el-form-item label="白名单" prop="ipWhitelist" :label-width="formLabelWidth">
          <el-input v-model="editform.ipWhitelist" autocomplete="on" style="width:50%"></el-input>
        </el-form-item>

        <el-form-item label="是否B2B" :label-width="formLabelWidth">
          <el-radio-group v-model="editform.hasB2b" @change="changeEditB2b">
            <el-radio label="T">是</el-radio>
            <el-radio label="F">否</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="备注" :label-width="formLabelWidth">
          <el-input v-model="editform.memo" autocomplete="on" style="width:50%" maxlength="64"></el-input>
        </el-form-item>

        <el-form-item label="库存分配" :label-width="formLabelWidth">
          <el-table :data="editform.shops">
            <el-table-column prop="shopName" label="店铺名称"></el-table-column>

            <el-table-column prop="prop" label="分配方式">
              <template slot-scope="scope">
                <el-form-item>
                  <el-select v-model="scope.row.disType" placeholder="请选择" style="width:130Px">
                    <el-option v-for="types in allotType" :key="types.value" :label="types.label" :value="types.value"></el-option>
                  </el-select>
                </el-form-item>
              </template>
            </el-table-column>

            <el-table-column prop="prop" label="百分比(数量)">
              <template slot-scope="scope">
                <el-form-item>
                  <el-input v-model="scope.row.combPercent"></el-input>
                </el-form-item>
              </template>
            </el-table-column>

            <el-table-column prop="prop" label="优先级">
              <template slot-scope="scope">
                <el-input-number v-model="scope.row.priority" :min="1" :max="30"></el-input-number>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align:center">
        <el-button @click="editdialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="savePtnStore">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    // 验证邮箱规则
    var checkEmail = (rule, value, callback) => {
      // 正则表达式
      const regEmail = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(\.[a-zA-Z_-])+/;
      if (regEmail.test(value)) {
        return callback();
      }
      callback(new Error("请输入合法的邮箱"));
    };
    // 验证手机号规则
    var checkMobile = (rule, value, callback) => {
      const regMobile = /^(13[0-9]|15[012356789]|17[678]|18[0-9]|14[57])[0-9]{8}$/;
      // 符合规则
      if (regMobile.test(value)) {
        return callback();
      }
      callback(new Error("请输入合法的手机号"));
    };

    return {
      form: {
        ptnCode: "",
        strCode: "",
        ownerCode: "",
        warehouseCode: "",
      },
      addform: {
        ptnCode: "",
        strCode: "",
        ownerCode: "",
        ownerName: "",
        warehouseCode: "",
        apiUrl: "",
        ftpUrl: "",
        ftpAccount: "",
        ftpPassword: "",
        ipWhitelist: "",

        shops: [],
        memo: "",
        hasB2b: "F",
      },
      editform: {
        ptnCode: "",
        strCode: "",
        ownerCode: "",
        warehouseCode: "",
        apiUrl: "",
        ftpUrl: "",
        ftpAccount: "",
        ftpPassword: "",
        ipWhitelist: "",

        shops: [],
        memo: "",
        hasB2b: "F",
      },
      allotType: [
        // 固定数量的店铺  优先级需>按比例的 店铺
        { value: "0", label: "请选择" },
        { value: "2", label: "按比例%" },
        { value: "1", label: "固定数量" },
      ],
      selvalue: "",
      dialogFormVisible: false,
      editdialogFormVisible: false,
      formLabelWidth: "80px",
      rules: {
        ptnCode: [{ required: true, message: "请选择商家", trigger: "change" }],
        strCode: [
          { required: true, message: "请输入仓库ID", trigger: "change" },
        ],
        ownerName: [
          { required: true, message: "请输入货主名称", trigger: "blur" },
          {
            min: 3,
            max: 20,
            message: "长度在 3 到 20 个字符",
            trigger: "blur",
          },
        ],
        ownerCode: [
          { required: true, message: "请输入货主ID", trigger: "blur" },
          {
            min: 3,
            max: 20,
            message: "长度在 3 到 20 个字符",
            trigger: "blur",
          },
        ],
        warehouseCode: [
          { required: true, message: "请输入仓库编码", trigger: "blur" },
          {
            min: 3,
            max: 20,
            message: "长度在 3 到 20 个字符",
            trigger: "blur",
          },
        ],
        apiUrl: [
          { required: true, message: "请输入API地址", trigger: "blur" },
          {
            min: 3,
            max: 20,
            message: "长度在 3 到 20 个字符",
            trigger: "blur",
          },
        ],
        ftpUrl: [
          { required: true, message: "请输入FTP地址", trigger: "blur" },
          { validator: checkMobile, trigger: "blur" },
        ],
        ftpAccount: [
          { required: true, message: "请输入FTP账号", trigger: "blur" },
          { validator: checkMobile, trigger: "blur" },
        ],
        ftpPassword: [
          { required: true, message: "请输入FTP密码", trigger: "blur" },
        ],
      },
      shops: [],
      storeLists: [],
      PartnerLists: [],
      ptnStrLists: [],
      queryInfo: {
        query: "",
        pagenum: 1,
        pagesize: 10,
      },
      currentPage: 1,
      total: 0,
      loading: true,
    };
  },
  methods: {
    // 搜索
    onSubmit() {
      this.queryInfo.pagenum = 1;
      this.currentPage = 1;
      this.queryInfo.query = this.form;
      this.getPtnStrLists();
    },
    handleSizeChange(val) {
      this.queryInfo.pagesize = val;

      this.getPtnStrLists();
    },

    handleCurrentChange(val) {
      this.queryInfo.pagenum = val;

      this.getPtnStrLists();
    },

    // 关闭新增窗口
    addDilogClosed() {
      this.addform.Shops = "";
      this.$refs.addformRef.resetFields();
    },
    // 关闭新增窗口
    editDilogClosed() {
      this.$refs.editformRef.resetFields();
    },

    // 删除映射关系
    async delPtnStr(strid) {
      // 弹框询问是否删除
      const confirmResult = await this.$confirm(
        "此操作将永久删除该货主, 是否继续?",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      ).catch((err) => err);

      // 确认删除
      if (confirmResult == "confirm") {
        await this.$http
          .delete("delptnstr/" + strid)
          .then((response) => {
            this.$message.success("删除成功");

            this.getPtnStrLists();
          })
          .catch((error) => {
            return this.$message.error(error.response.data.message);
          });
      }
    },
    // 显示修改对话框
    async showEditDilog(row) {
      let copy = Object.assign({}, row);
      this.shops = copy.shops;
      this.editform = copy;
      this.editdialogFormVisible = true;
    },
    // 新增商家&仓库
    async addPtnStore() {
      // this.$refs.addformRef.validate(async (valid) => {
      //   if (!valid) return;

      await this.$http
        .post("addptnstr", this.addform)
        .then((response) => {
          this.$message.success("添加商家&仓库成功");
          this.dialogFormVisible = false;
          this.addform.shops = "";
          this.getPtnStrLists();
        })
        .catch((error) => {
          return this.$message.error(error.response.data.message);
        });
      // });
    },
    // 修改映射关系
    async savePtnStore() {
      // this.$refs.editformRef.validate(async (valid) => {
      //   if (!valid) return;

      await this.$http
        .post("editptnstr", this.editform)
        .then((response) => {
          this.$message.success("修改成功");
          this.editdialogFormVisible = false;
          this.getPtnStrLists();
        })
        .catch((error) => {
          return this.$message.error(error.response.data.message);
        });
      // });
    },
    // 获取商家列表
    async getPartnerLists() {
      await this.$http
        .post("ptnlists", {
          query: "",
          pagenum: 1,
          pagesize: 100,
        })
        .then((response) => {
          const res = response.data;
          this.PartnerLists = res.data.data;
        })
        .catch((error) => {
          return this.$message.error(error.response.data.message);
        });
    },
    // 获取仓库列表
    async getStoreLists() {
      await this.$http
        .post("strlists", {
          query: "",
          pagenum: 1,
          pagesize: 100,
        })
        .then((response) => {
          const res = response.data;
          this.storeLists = res.data.data;
        })
        .catch((error) => {
          return this.$message.error(error.response.data.message);
        });
    },
    // 获取货主列表
    async getPtnStrLists() {
      this.loading = true;
      await this.$http
        .post("ptnstrlists", this.queryInfo)
        .then((response) => {
          const res = response.data;
          this.ptnStrLists = res.data.data;
          this.total = res.data.total;
          this.loading = false;
        })
        .catch((error) => {
          this.loading = false;
          return this.$message.error(error.response.data.message);
        });
    },
    // 商家变更
    async changePtn(cb) {
      await this.$http
        .post("shopsbyptn", { ptnCode: cb })
        .then((response) => {
          const res = response.data;
          this.shops = res.data;
          this.addform.shops = res.data;
        })
        .catch((error) => {
          return this.$message.error(error.response.data.message);
        });
    },

    // 仓库变更事件
    changeStr(cb) {
      for (const i in this.storeLists) {
        if (
          this.storeLists.hasOwnProperty(i) &&
          this.storeLists[i].strCode === cb
        ) {
          this.addform.warehouseCode = this.storeLists[i].warehouseCode;
          this.addform.apiUrl = this.storeLists[i].apiUrl;
          this.addform.ftpUrl = this.storeLists[i].ftpUrl;
        }
      }
    },
    // B2B 切换
    changeAddB2b(cb) {
      if (cb == "T") {
        this.addform.shops = [];
      } else {
        this.addform.shops = this.shops;
      }
    },
    changeEditB2b(cb) {
      if (cb == "T") {
        this.editform.shops = [];
      } else {
        this.editform.shops = this.shops;
      }
    },

    // 仓库变更事件
    changeEditStr(cb) {
      for (const i in this.storeLists) {
        if (
          this.storeLists.hasOwnProperty(i) &&
          this.storeLists[i].strCode === cb
        ) {
          console.log(this.storeLists[i].strCode);
          this.editform.warehouseCode = this.storeLists[i].warehouseCode;
          this.editform.apiUrl = this.storeLists[i].apiUrl;
          this.editform.ftpUrl = this.storeLists[i].ftpUrl;
        }
      }
    },
  },
  created() {
    this.getPtnStrLists();
    this.getPartnerLists();
    this.getStoreLists();
  },
};
</script>

<style lang="less" scoped>
.bg-purple-dark {
  background: #99a9bf;
}
.bg-purple {
  background: #d3dce6;
}
.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  border-radius: 4px;
  min-height: 36px;
}
.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}
.form-card {
  margin-bottom: 15px;
}
.add-card {
  width: 50%;
}
.el-dialog {
  /* 表单页面居中，宽度50% ,legend颜色设置，legend圆角*/
  border: 2px solid #dcdfe6;
  text-align: center;
  border-radius: 8px;
  margin: 0 auto;
  width: 50%;
}
</style>


// WEBPACK FOOTER //
// src/views/basic/Ptnstore.vue